export default __webpack_public_path__ + "static/media/money.5a37869a.svg";